import cn from "classnames";
import React from "react";
import { Badge, Label } from "reactstrap";
import { WebMessage } from "../../../cores/webChat/interfaces/api/get-messages";
import moment from "moment"
import { Message } from "../../../cores/socialChat/interfaces/conversations";
import Avatar from "../Avatar";
import { getFirstLetters } from "../../utils/stringUtils";

interface Props {
  message: WebMessage | Message;
  itsMe: boolean;
}

export default function MessageRow(props: Props) {
  const { message, itsMe } = props;

  return (
    <div
      key={message.id}
      className={cn(
        "w-100 d-flex",
        { "justify-content-end": itsMe }
      )}
    >
      <Label
        className={cn(
          "w-75 m-1 d-flex flex-column",
          {
            "align-items-end": itsMe,
            "align-items-start": !itsMe
          }
        )}
      >
        <div className="d-flex">
          <div className="position-relative">
            <Badge
              color={itsMe ? 'primary' : 'light'}
              className={cn(
                "p-3 text-wrap text-left fs-15",
                { "text-light": itsMe }
              )}
            >
              {message.message}
            </Badge>
            <div
              className={cn({
                "ballon-right": itsMe,
                "ballon-left": !itsMe,
              })}
            ></div>
          </div>
          {itsMe && (
            <Avatar
              className="ml-2"
              label={getFirstLetters(message.from.name)}
              image={message.from.avatarUrl}
            />
          )}
        </div>
        <Label className="text-muted px-2 m-0" size="sm">
          {moment(message.timestamp.full).format("hh:mm a")}
        </Label>
      </Label>
    </div>
  );
}
